import DashboardLayout from "../layout/dashboard/DashboardLayout.vue";
import Login from "../pages/Login.vue";
import Dashboard from "../pages/dashboard/Dashboard.vue";
import UserManagement from "../pages/user/UserList/UserList.vue";
import UserComponent from "../pages/user/UserComponent.vue"
import UserDetail from "../pages/user/UserDetail/UserDetail.vue";
import UserChangePassword from "../pages/user/UserChangePassword/UserChangePassword";
import Organization from "../pages/organization/Organization";
import AIModelComponent from "../pages/ai_model/AIModelComponent";
import AIModelList from "../pages/ai_model/ai_model_list/AIModelList";
import AIModelDetail from "../pages/ai_model/ai_model_detail/AIModelDetail";
import AIModelInference from "../pages/ai_model/ai_model_inference/AIModelInference";
import AIModelTrain from "../pages/ai_model/ai_model_train/AIModelTrain";
import AIModelLayerComponent from "../pages/ai_model/ai_model_layer/AIModelLayerComponent";
import AIModelLayerList from "../pages/ai_model/ai_model_layer/ai_model_layer_list/AIModelLayerList";
import AIModelLayerDetail from "../pages/ai_model/ai_model_layer/ai_model_layer_detail/AIModelLayerDetail";
import SubscriptionContainer from "../pages/subscription/SubscriptionContainer.vue";
import SubscriptionChoosePlan from "../pages/subscription/choosePlan/ChooseSubscriptionPlan.vue";

const routes = [
    { path: "/login", component: Login, name: 'login', meta: { title: 'login' } },
    { path: "/logout", component: Login, name: 'logout' },
    { path: "*", redirect: "/login", },
    {
        path: "/",
        component: DashboardLayout,
        redirect: "/dashboard",
        meta: { requiresAuth: true },
        children: [{
                path: "dashboard",
                name: "dashboard",
                component: Dashboard,
                meta: { title: 'dashboard' }
            },
            {
                path: "users",
                name: "User",
                component: UserComponent,
                redirect: 'users/list',
                children: [
                    { path: "list", name: "UserManagement", component: UserManagement, meta: { title: 'user_list' } },
                    { path: "create", name: "UserCreate", component: UserDetail, meta: { title: 'user_create' } },
                    { path: ":id", name: "UserDetail", component: UserDetail, meta: { title: 'user_update' } },
                    { path: ":id/changepassword", name: 'UserChangePassword', component: UserChangePassword, meta: { title: 'user_change_password' } },
                ]
            },
            {
                path: "organization",
                name: "Organization",
                component: Organization,
                meta: { title: 'organization' }
            },
            {
                path: "aimodel",
                name: "aimodel",
                component: AIModelComponent,
                redirect: 'aimodel/list',
                children: [
                    { path: "list", name: "aimodel-list", component: AIModelList, meta: { title: 'ai_model_list' } },
                    {
                        path: "create",
                        name: "aimodel-create",
                        component: AIModelDetail,
                        meta: {
                            title: 'ai_model_create'
                        }
                    },
                    {
                        path: "inference",
                        name: "aimodel-inference",
                        component: AIModelInference,
                        meta: {
                            title: 'ai_model_inference'
                        }
                    },
                    {
                        path: "train",
                        name: "aimodel-train",
                        component: AIModelTrain,
                        meta: {
                            title: 'ai_model_train'
                        }
                    },
                    {
                        path: ":id",
                        name: "aimodel-detail",
                        component: AIModelDetail,
                        meta: {
                            title: 'ai_model_update'
                        }
                    },
                    {
                        path: ":id/aimodel-layer",
                        name: "aimodel-layer",
                        component: AIModelLayerComponent,
                        redirect: ':id/aimodel-layer/list',
                        children: [
                            {
                                path: "list",
                                name: "aimodel-layer-list",
                                component: AIModelLayerList,
                                meta: {
                                    title: 'ai_model_layer_list'
                                }
                            },
                            {
                                path: ":layer_no",
                                name: "aimodel-layer-detail",
                                component: AIModelLayerDetail,
                                meta: {
                                    title: 'ai_model_layer_update'
                                }
                            },
                            {
                                path: "/aimodel-layer-create",
                                name: "aimodel-layer-create",
                                component: AIModelLayerDetail,
                                meta: {
                                    title: 'ai_model_layer_create'
                                }
                            }
                        ],
                    },
                    
                ]
            },
            {
                path: "subscription",
                component: SubscriptionContainer,
                name: 'subscription',
                redirect: 'subscription/choose-plan',
                meta: { title: 'subscription' },
                children: [
                    {
                        path: "choose-plan",
                        name: "subscription-choose-plan",
                        component: SubscriptionChoosePlan,
                        meta: { title: 'subscription' },
                    },
                ]
            }
        ]
    }
];

export default routes;
